import { useState, useEffect, useContext } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { Redirect } from 'react-router-dom';
import { Msg, Button } from 'react-weui';
import PropTypes from 'prop-types';
import * as Hashes from 'jshashes';
const MD5 = new Hashes.MD5();
import { formatDate, formatNumber } from 'lib/formatter.ts';
import TopNav from 'components/topNav.js';
import * as MobileActions from 'actions/index.ts';
import CompanyService from 'services/company2';
import Util from 'lib/util.js';
import useDetail from 'hooks/useDetail';
import { ActionContext } from 'actions/context';
import Modal from 'components/modal';
import CommonFns from 'functions/common.ts';
import Download from 'components/download.js';

// 重要度
const ImportList = {
  1: '低',
  2: '中',
  3: '高'
};

function QuestionnaireDetail(props) {
  const Config = {
    sale: {
      title: '客户问卷详情',
      apiPath: '/b2bquestionnaire/CusNaire/queryAck',
      arrEnumField: [
        // {
        //   mainKey: 'B02_Question_Pub_Status',
        //   subKey: 'status',
        //   value: 'statusName'
        // },
        {
          mainKey: 'B02_Question_Ack_Status',
          subKey: 'ackStatus',
          value: 'ackStatusName'
        }
      ],
      idField: 'id',
      detailParams: {
        questionnaireCode: props.match.params.questionnaireCode,
        customerCode: props.match.params.customerCode
      }
    }
  };

  const config = Config[props.type];

  const {
    companyCode,
    inited,
    error,
    updateTs,
    redirect,
    decimalPlace,
    fileList,
    moreSign1,
    handleMore,
    setShowLoading,
    setFileList,
    detail,
    setDetail,
    workflow,
    forceUpdate,
    self
  } = useDetail(props, config);

  const { state, dispatch } = useContext(ActionContext);
  const [boxState, setBoxState] = useState({
    1: true
  });
  const [list, setList] = useState([]);

  //处理详情数据
  self.afterGetDetail = function (data) {
    if (Array.isArray(data.b2BCusQuestionAckRespList)) {
      data.b2BCusQuestionAckRespList.forEach(item => {
        let answerAckList = Array.isArray(item.answerAckList)
          ? item.answerAckList
          : Util.jsonDecode(item.answerAckList);
        answerAckList = answerAckList || [];

        if (Array.isArray(item.b2BQuestionOptionList)) {
          if (item.answerType === '300500') {
            item.fileMd5s = item.b2BQuestionOptionList.map(
              row => row.questionValue
            );
            item.vFileMd5s = answerAckList;
            item.businessKey = MD5.hex(item.questionCode + item.id);
          }
        }
      });
    }
    setDetail(data);
  };

  //初始化默认企业
  useEffect(() => {
    const { match } = props;
    let routeCompanyCode = match.params.companyCode;
    self.init(routeCompanyCode);
    //卸载时
    return function unmount() {
      if (self.toastTimer) {
        clearTimeout(self.toastTimer);
      }
      if (self.loadingTimer) {
        clearTimeout(self.loadingTimer);
      }
      if (self.errorTimer) {
        clearTimeout(self.errorTimer);
      }
    };
  }, [self, props, config]);

  //根据依赖多次执行
  useEffect(() => {
    self.getDetail();
  }, [companyCode, self]);

  //查看回复附件
  function showFileList(item) {
    const { actions } = props;
    setShowLoading(true);
    CompanyService.getFileList(25, item.businessKey, '', '', companyCode).then(
      res => {
        setShowLoading(false);
        if (Array.isArray(res)) {
          let arr = res.map(row => {
            return { ...row };
          });
          setFileList(arr);
        }
      }
    );
    actions.openDownloadModal();
  }

  //显示错误
  if (error !== null) {
    return <Msg {...error} />;
  }

  if (redirect !== null) {
    return <Redirect to={redirect} />;
  }

  return (
    <div>
      <TopNav inited={inited} />
      <div className="m-details-container">
        <div className="m-details-item">
          <div className="details-item-title">
            <label>基础信息</label>
          </div>
          <div className="details-item-content">
            <div className="content-line">
              <ul className="field-list">
                <li>
                  <span className="field-label">问卷标题</span>
                  <div className="field-value">{detail.questionnaireTitle}</div>
                </li>
                <li>
                  <span className="field-label">问卷描述</span>
                  <div className="field-value">{detail.questionnaireDesc}</div>
                </li>
                <li>
                  <span className="field-label">发起方</span>
                  <div className="field-value">{detail.customerName}</div>
                </li>
                <li>
                  <span className="field-label">开始时间</span>
                  <div className="field-value">
                    {formatDate(detail.startTime)}
                  </div>
                </li>
                <li>
                  <span className="field-label">结束时间</span>
                  <div className="field-value">
                    {formatDate(detail.endTime)}
                  </div>
                </li>
                <li>
                  <span className="field-label">重要度</span>
                  <div className="field-value">
                    {ImportList[detail.importanceDegree]}
                  </div>
                </li>
                <li>
                  <span className="field-label">状态</span>
                  <div className="field-value">
                    <span
                      className={
                        'u-sign ' +
                        CommonFns.getStatusClass(
                          'B02_Question_Ack_Status',
                          detail.ackStatus
                        )
                      }
                    >
                      {detail.ackStatusName}
                    </span>
                  </div>
                </li>
              </ul>
            </div>
          </div>
        </div>

        {/*问卷回复 */}
        {!Util.isEmpty(detail.b2BCusQuestionAckRespList) && (
          <div className="m-details-item">
            <div className="details-item-title">
              <label>问卷回复</label>
            </div>

            <div className="details-item-content">
              {detail.b2BCusQuestionAckRespList.map((item, index) => (
                <div className="content-line line-list-item" key={index}>
                  <div className="line-list-item-title">
                    <span>
                      <b>
                        {index + 1}. {item.questionName}
                      </b>
                    </span>
                  </div>
                  <ul className="field-list">
                    {item.answerAckList.map((row, idx) => (
                      <li key={index + idx + ''}>
                        {item.answerType === '300500' && (
                          <div className="field-value">
                            <span
                              className="attachment"
                              onClick={() => showFileList(item)}
                            >
                              1个附件
                            </span>
                          </div>
                        )}
                        {item.answerType !== '300500' && (
                          <div className="field-value">{row}</div>
                        )}
                      </li>
                    ))}
                  </ul>
                </div>
              ))}
            </div>
          </div>
        )}
      </div>
      {
        // 附件查看
        Array.isArray(fileList) && fileList.length > 0 && (
          <Download fileList={fileList} />
        )
      }
      <Modal></Modal>
    </div>
  );
}

QuestionnaireDetail.propTypes = {
  data: PropTypes.object.isRequired,
  actions: PropTypes.object.isRequired
};

const mapStateToProps = state => {
  return {
    data: state.login
  };
};

const mapDispatchToProps = dispatch => {
  return {
    actions: bindActionCreators(MobileActions, dispatch)
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(QuestionnaireDetail);
